<div class="dv-edit-prdct">
  <h2 mat-dialog-title style="margin: 0; padding: 20px; border-bottom: 1px solid #dee2e6; font-weight: 600; font-size: 24px;">Edit Product</h2>

  <div mat-dialog-content style="padding: 20px;">
    <!-- Title Field -->
    <div class="form-section" [ngClass]="data.isSuperAdmin == 'true' ? 'no-display': 'displayclss'">
      <mat-form-field class="example-full-width">
        <mat-label>Title</mat-label>
        <input matInput class="form-control" [(ngModel)]="data.title" placeholder="Enter product title">
      </mat-form-field>
    </div>

    <!-- Description Field -->
    <div class="form-section" [ngClass]="data.isSuperAdmin == 'true' ? 'no-display': 'displayclss'">
      <mat-form-field class="example-full-width">
        <mat-label>Description</mat-label>
        <textarea matInput class="form-control" rows="4" [(ngModel)]="data.description" placeholder="Enter product description"></textarea>
      </mat-form-field>
    </div>

    <!-- Labels Section -->
    <div class="form-section">
      <h5 style="margin-bottom: 15px; font-weight: 600;">Labels <small style="font-size: 11px; color: #6c757d;">(Max 3)</small></h5>

      <div class="row lbl-hndngs" style="margin-bottom: 10px;">
        <div class="col-md-3">
          <strong>Label Name</strong>
        </div>
        <div class="col-md-3">
          <strong>Background Color</strong>
        </div>
        <div class="col-md-3">
          <strong>Text Color</strong>
        </div>
        <div class="col-md-1">
          <strong>Actions</strong>
        </div>
        <div class="col-md-2">
          <strong>Preview</strong>
        </div>
      </div>

      <div class="row label-row" *ngFor="let item of productLabels; index as i" style="margin-bottom: 10px; align-items: center;">
        <div class="col-md-3">
          <input matInput type="text" class="form-control" [(ngModel)]="item.text" placeholder="Label text">
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <input matInput type="text" class="form-control" [(ngModel)]="item.backgroundColor" (input)="onColorInputChange($event, item, 'background')" placeholder="#000000">
            <span class="input-group-btn spn-clr-pllt">
              <button class="btn btn-default color-picker" type="button" style="padding: 0; border: 1px solid #ccc;">
                <img src="../../../../assets/img/color-picker-icon.png" alt="Color-picker" class="Color-picker-icon" style="width: 30px; height: 30px;">
                <input matInput type="color" class="color-input" [(ngModel)]="item.backgroundColor" (input)="onColorInputChange($event, item, 'background')" style="position: absolute; opacity: 0; width: 30px; height: 30px; cursor: pointer;">
              </button>
            </span>
          </div>
        </div>

        <div class="col-md-3">
          <div class="input-group">
            <input type="text" matInput class="form-control" [(ngModel)]="item.textColor" (input)="onColorInputChange($event, item, 'text')" placeholder="#FFFFFF">
            <span class="input-group-btn spn-clr-pllt">
              <button class="btn btn-default color-picker" type="button" style="padding: 0; border: 1px solid #ccc;">
                <img src="../../../../assets/img/color-picker-icon.png" alt="Color-picker" class="Color-picker-icon" style="width: 30px; height: 30px;">
                <input matInput type="color" class="color-input" [(ngModel)]="item.textColor" (input)="onColorInputChange($event, item, 'text')" style="position: absolute; opacity: 0; width: 30px; height: 30px; cursor: pointer;">
              </button>
            </span>
          </div>
        </div>

        <div class="col-md-1 dv-icns" style="text-align: center;">
          <i *ngIf="productLabels.length > 1" class="fa fa-minus-circle" (click)="fn_RemoveLabel(i)" style="cursor: pointer; color: #dc3545; font-size: 20px;" title="Remove label"></i>
          <i *ngIf="productLabels.length - 1 == i && productLabels.length < 3" class="fa fa-plus-circle" (click)="fn_AddLabel()" style="cursor: pointer; color: #28a745; font-size: 20px; margin-left: 7px;" title="Add label"></i>
        </div>

        <div class="col-md-2">
          <div *ngIf="item.text" class="badge dv-lbl-prvew" [ngStyle]="{'background-color': item.backgroundColor, 'color': item.textColor}" style="padding: 5px 10px; font-size: 12px;">
            {{item.text}}
          </div>
        </div>
      </div>
    </div>

    <!-- Tags Section -->
    <div class="form-section" style="margin-top: 30px;">
      <h5 style="margin-bottom: 15px; font-weight: 600;">Tags <small style="font-size: 11px; color: #6c757d;">(Max 15)</small></h5>

      <!-- Decoration Type Change Info -->
      <div *ngIf="showDecorationTypeChangeInfo" class="decoration-change-info">
        <i class="fa fa-info-circle"></i>
        <span>
          Decoration type has been updated from
          <strong class="old-tag">"{{data.oldDecorationTypeTag}}"</strong>
          to
          <strong class="new-tag">"{{data.decorationType}}"</strong>
        </span>
      </div>

      <div class="row lbl-hndngs" style="margin-bottom: 10px;">
        <div class="col-md-5">
          <strong>Tag Name</strong>
        </div>
        <div class="col-md-2">
          <strong>Actions</strong>
        </div>
        <div class="col-md-5">
          <strong>Preview</strong>
        </div>
      </div>

      <div class="row tag-row" *ngFor="let item of productTags; index as j" style="margin-bottom: 10px; align-items: center;">
        <div class="col-md-5">
          <input matInput type="text" class="form-control" [(ngModel)]="item.tagtext" [readonly]="item.isDefault" [disabled]="item.isDefault" [placeholder]="item.isDefault ? 'Decoration Type (Auto)' : 'Tag text'">
        </div>

        <div class="col-md-2 dv-icns" style="text-align: center;">
          <i *ngIf="productTags.length > 1 && !item.isDefault" class="fa fa-minus-circle" (click)="fn_RemoveTag(j)" style="cursor: pointer; color: #dc3545; font-size: 20px;" title="Remove tag"></i>
          <i *ngIf="productTags.length - 1 == j && productTags.length < 15" class="fa fa-plus-circle" (click)="fn_AddTag()" style="cursor: pointer; color: #28a745; font-size: 20px; margin-left: 7px;" title="Add tag"></i>
        </div>

        <div class="col-md-5">
          <div *ngIf="item.tagtext" class="badge dv-tag-prvew" [class.default-tag]="item.isDefault" style="padding: 5px 10px; font-size: 12px; background-color: #6c757d; color: white;">
            {{item.tagtext}}
            <span *ngIf="item.isDefault" style="margin-left: 5px; font-size: 10px;">(Default)</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Dialog Actions -->
  <div mat-dialog-actions style="padding: 15px 20px; border-top: 1px solid #dee2e6; justify-content: flex-end;">
    <button mat-button (click)="dialogRef.close()" style="margin-right: 10px;">Cancel</button>
    <button mat-raised-button color="primary" (click)="onClose()" cdkFocusInitial>Save Changes</button>
  </div>
</div>